"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notification_container_1 = require("./notification-container");
var notification_actions_1 = require("./notification.actions");
var activeTimers = {};
exports.NotificationMiddleware = function (api) {
  return function (dispatchNext) {
    return function (action) {
      var previousNotificationState = "payload" in action && action.payload !== undefined ? getNotificationById(action.payload.id) : undefined;
      dispatchNext(action);
      if (notification_actions_1.notificationAddActionMatcher(action)) {
        setTimeout(function () {
          return api.dispatch(notification_actions_1.notificationLifecycleAction(action.payload.id, notification_container_1.NotificationLifecycle.ACTIVE));
        });
      }
      if (notification_actions_1.notificationUpdateActionMatcher(action)) {
        var currentNotificationState = getNotificationById(action.payload.id);
        if (currentNotificationState && previousNotificationState && previousNotificationState.type !== currentNotificationState.type) {
          setTimeout(function () {
            return api.dispatch(notification_actions_1.notificationLifecycleAction(action.payload.id, notification_container_1.NotificationLifecycle.ACTIVE));
          });
        }
      }
      if (notification_actions_1.notificationLifecycleActionMatcher(action)) {
        var _currentNotificationState = getNotificationById(action.payload.id);
        if (!_currentNotificationState) {
          return;
        }
        var nextLifecycleStage = getNextLifecycleStage(_currentNotificationState.lifecycle, _currentNotificationState.type);
        if (nextLifecycleStage) {
          if (activeTimers[action.payload.id]) {
            clearTimeout(activeTimers[action.payload.id]);
          }
          activeTimers[action.payload.id] = setTimeout(function () {
            return api.dispatch(notification_actions_1.notificationLifecycleAction(action.payload.id, nextLifecycleStage.stage));
          }, nextLifecycleStage.duration);
          return;
        }
      }
      function getNotificationById(id) {
        return api.getState().notificationState.notifications.find(function (n) {
          return n.id === id;
        });
      }
    };
  };
};
function getNextLifecycleStage(lifecycle, type) {
  var duration = getDurationForType(type);
  switch (lifecycle) {
    case undefined:
    case notification_container_1.NotificationLifecycle.ACTIVE:
      if (!duration) {
        return;
      }
      return {
        stage: notification_container_1.NotificationLifecycle.OLD,
        duration: duration
      };
    case notification_container_1.NotificationLifecycle.OLD:
      return {
        stage: notification_container_1.NotificationLifecycle.EXPIRED,
        duration: getDurationForType("expired")
      };
  }
}
function getDurationForType(type) {
  switch (type) {
    case "expired":
      return 300;
    case "success":
      return 4000;
    case "error":
    case "inProgress":
    case "warning":
    case "info":
      return;
    default:
      return 3000;
  }
}